__turbopack_context__.v({
  "container": "CartItemList-module-scss-module__0v2rBG__container",
  "emptyList": "CartItemList-module-scss-module__0v2rBG__emptyList",
});
